module.exports = __webpack_public_path__ + "assets/ic_mindWeather.478da2f5.svg";